module.exports = __webpack_public_path__ + "assets/ab737b5f2bc4e21092699f23f1bd2d2a.mp3";